import { FC, MouseEventHandler } from "react";
import { ChevronRight } from "lucide-react";
import { MEDIUM_ICON_SIZE_STYLES } from "../../../ui/styles";

type RowButtonProps = { onClick?: MouseEventHandler<HTMLButtonElement> };

export const RowButton: FC<RowButtonProps> = ({ onClick }) => {
  return (
    <button onClick={onClick} className="absolute inset-0 h-full w-full">
      <div className="absolute right-2 top-1/2 -translate-y-1/2 transform sm:right-6">
        <ChevronRight
          className={`justify-self-end text-stone-300 underline hover:text-stone-400 dark:text-stone-600 dark:hover:text-stone-500 sm:-mr-2 ${MEDIUM_ICON_SIZE_STYLES}`}
        />
      </div>
    </button>
  );
};
